// 컴포넌트별 실제 사용 화면 — 메뉴 위치 + 앱 URL(갤러리에서 새 창으로 연다).
// 2026-10-16 수집 스냅샷: import 를 라우트된 페이지까지 따라가 routes.ts 경로를 얻고,
// 메뉴 라벨은 registry/menu-config.ts 기준이다(실제 LNB 는 DB 메뉴 트리라 라벨이 다를 수 있다).
// 메뉴에 없는 화면은 "(진입: …)" 으로 들어가는 길을 적는다. 외부공유(공개) 화면은 공유 쿠키가 필요해 링크하지 않는다(path '').
// 경로에 id 가 필요한 화면은 가장 가까운 목록 화면으로 연결하고 note 에 적는다.

export interface Screen {
  label: string;
  /** 앱 URL. '' 이면 링크하지 않는다 */
  path: string;
  note?: string;
}

const SITES_EMBED: Screen = { label: '현장 목록 > (진입: 현장 카드 클릭 → 작업물 슬라이드오버 \'공사스케줄\' 탭)', path: '/sites', note: '임베드 view' };
const SCH_GANTT = '/agents/scheduler?view=gantt';
const SCH_CAL = '/agents/scheduler?view=cal-b2';
const SCH_LIST = '/agents/scheduler?view=work-type';

const WL_ORDER_LIST: Screen = { label: '인디공사현황 > 작업요청 > 작업요청 목록', path: '/agents/work-log/workorder' };
const WL_ORDER_NEW: Screen = { label: '인디공사현황 > 작업요청 > 작업요청 작성', path: '/agents/work-log/workorder/new' };
const WL_ORDER_BULK: Screen = { label: '인디공사현황 > 작업요청 > 작업요청 작성 > (진입: 상단 탭 \'일괄 작업요청\')', path: '/agents/work-log/workorder/bulk' };
const WL_FR_LIST: Screen = { label: '인디공사현황 > 현장보고 > 현장보고 목록', path: '/agents/work-log/field-reports' };
const WL_FR_NEW: Screen = { label: '인디공사현황 > 현장보고 > 현장보고 작성', path: '/agents/work-log/field-reports/new' };
const WL_STATUS: Screen = { label: '인디공사현황 > 공사현황', path: '/agents/work-log/site-reports' };
const WL_CR_EDIT: Screen = { label: '인디공사현황 > 현장보고 편집·발송', path: '/agents/work-log/customer-reports/edit' };
const WL_PANEL = [WL_ORDER_LIST, WL_FR_LIST, WL_STATUS, WL_CR_EDIT];
const SHARE_FR: Screen = { label: '외부공유 수신 화면 (공개) — 반장 현장보고 작성', path: '', note: '/share/WORK_ORDER_RECIPIENT/field-report · 공유 쿠키 필요' };
const SHARE_WO: Screen = { label: '외부공유 수신 화면 (공개) — 반장 작업요청 안내', path: '', note: '/share/WORK_ORDER_RECIPIENT · shareId·공유 쿠키 필요' };
const WL_REST: Screen = { label: '외 3곳', path: '', note: '작업요청 일괄(/agents/work-log/workorder/bulk), 현장보고 작성(/agents/work-log/field-reports/new), 공유이력(/agents/worklog/share-history)' };

const PO_SITE: Screen = { label: '인디포토 > 현장', path: '/agents/photo-organizer/site-list' };
const PO_SEARCH: Screen = { label: '인디포토 > 검색', path: '/agents/photo-organizer/search' };
const PO_SEND: Screen = { label: '인디포토 > 공유 > 공유하기', path: '/agents/photo-organizer/share-send' };
const PO_HISTORY: Screen = { label: '인디포토 > 공유 > 발송 이력', path: '/agents/photo-organizer/share-history' };
const PO_CLASSIFY: Screen = { label: '인디포토 > 사진 > (진입: 업로드 완료 후 자동 이동 / 현장 화면의 \'미분류 사진\' 카드)', path: '/agents/photo-organizer/classify-site', note: '현장 분류 화면' };
const PO_TAG: Screen = { label: '인디포토 > 사진 > (진입: 현장 분류 화면의 다음 버튼 / 현장 상세의 태그 등록)', path: '/agents/photo-organizer/tag-bulk-edit', note: '업로드 세션 상태 필요' };
const PO_SITE_DETAIL: Screen = { label: '인디포토 > 현장 > (진입: 현장 목록의 현장 카드 클릭)', path: '/agents/photo-organizer/site-list', note: '현장 상세는 id 필요 — 목록으로 연결' };

const BL_MANAGE: Screen = { label: '구독결제 > 구독결제 > (진입: 하위 화면의 뒤로가기)', path: '/agents/billing/manage', note: '구독·결제 관리' };
const BL_PM: Screen = { label: '구독결제 > 구독결제 > (진입: 구독관리의 \'결제수단 변경\' 버튼)', path: '/agents/billing/payment-method' };
const BL_CHECKOUT: Screen = { label: '구독결제 > 구독결제 > (진입: 요금제 화면의 체험/업그레이드 버튼)', path: '/agents/billing/checkout', note: 'tier 쿼리 필요 — /agents/billing 에서 진입' };
const BL_TIER: Screen = { label: '구독결제 > 구독결제 > (진입: 요금제 카드의 티어/주기 변경, 구독관리의 \'티어 변경\')', path: '/agents/billing/change-tier', note: 'tier 쿼리 필요 — /agents/billing 에서 진입' };
const BL_PLANS: Screen = { label: '구독결제 > 구독결제', path: '/agents/billing', note: '요금제 비교·선택' };

const PF_WRITE: Screen = { label: '인디포트폴리오 > 시공사례 작성', path: '/agents/portfolio/write' };

const FR_POPUP_HOSTS: Screen[] = [
  { label: '인디플래너 > 스케줄 관리 > 스케줄', path: SCH_GANTT },
  { label: '인디플래너 > 스케줄 관리 > 캘린더', path: SCH_CAL },
  { label: '인디플래너 > 스케줄 관리 > 리스트', path: SCH_LIST },
  { label: '인디플래너 > 현장 관리', path: '/agents/scheduler?view=site-list' },
  SITES_EMBED,
];
const SIGONG_HOSTS: Screen[] = [
  { label: '인디플래너 > 스케줄 관리 > 스케줄', path: SCH_GANTT, note: 'PartnerCard·SigongPopup 경유' },
  { label: '인디플래너 > 스케줄 관리 > 캘린더', path: SCH_CAL, note: 'SigongPopup 경유' },
  { label: '인디플래너 > 스케줄 관리 > 리스트', path: SCH_LIST, note: 'SigongPopup 경유' },
  SITES_EMBED,
];
const CUSTOMER_REPORT_HIDDEN: Screen = {
  label: '실제 화면 미노출',
  path: '',
  note: '유일한 사용처 CustomerReportSharePage 가 share/CUSTOMER_REPORT 를 셸 CustomerHomePage 에 넘겨(2026-10-02) 현재 렌더되지 않음',
};

export const SCREENS: Record<string, Screen[]> = {
  // billing
  'billing:PaymentMethodCardBody': [BL_MANAGE, { ...BL_PM, note: '직접 + PaymentMethodTile 경유' }, BL_CHECKOUT],
  'billing:PaymentMethodTile': [BL_PM, BL_CHECKOUT],
  'billing:PricingCard': [BL_PLANS, BL_TIER],
  'billing:ReasonSelectModal': [
    { ...BL_MANAGE, note: '구독 해지 사유 선택 모달' },
    { label: '구독결제 > 구독결제 > (진입: 구독관리·결제내역의 \'환불 신청\' 버튼)', path: '/agents/billing/refund' },
  ],
  'billing:withOwnerGuard': [
    { ...BL_PLANS, note: 'billing 라우트 9개 전체를 감싼다' },
    BL_MANAGE, BL_TIER, BL_PM, BL_CHECKOUT,
    { label: '구독결제 > 구독결제 > (진입: 구독관리의 \'결제 내역\' 버튼)', path: '/agents/billing/invoices' },
    { label: '외 3곳', path: '', note: 'staff-fee, referral, refund' },
  ],

  // photo-organizer
  'photo-organizer:ThumbImg': [
    PO_SITE, { ...PO_SEARCH, note: 'PhotoCard 경유' }, { ...PO_SEND, note: 'PhotoCard 경유' }, { ...PO_HISTORY, note: 'PhotoCard 경유' }, PO_CLASSIFY, PO_SITE_DETAIL,
    { label: '외 4곳', path: '', note: 'tag-bulk-edit, photo-detail, 외부공유 /share/PHOTO_ALBUM_SHARE, /sites 슬라이드오버 \'사진첩\' 탭' },
  ],
  'photo-organizer:PhotoViewerLayer': [
    PO_CLASSIFY, PO_TAG,
    { label: '외부공유 수신 화면 (공개) — 사진첩 공유', path: '', note: '/share/PHOTO_ALBUM_SHARE · 공유 토큰/쿠키 필요' },
  ],
  'photo-organizer:highlight': [PO_SITE, PO_SEARCH, PO_HISTORY],
  'photo-organizer:PhotoCard': [
    PO_SEARCH, PO_SEND, PO_HISTORY, PO_SITE_DETAIL, { ...PO_TAG, note: '태그 편집 화면' },
    { label: '현장 목록 > (진입: 현장 카드의 \'사진첩\' 태그 → 작업물 슬라이드오버 \'사진첩\' 탭)', path: '/sites', note: 'SiteDetailMain 임베드' },
  ],
  'photo-organizer:SearchBar': [PO_SITE, PO_SEARCH, PO_HISTORY],
  'photo-organizer:QrHandoffPanel': [{ label: '인디포토 > 사진', path: '/agents/photo-organizer/upload' }],
  'photo-organizer:AssigneeFilterField': [PO_SITE, PO_SEARCH, PO_CLASSIFY],

  // portfolio
  'portfolio:ThumbImg': [
    { ...PF_WRITE, note: 'PhotoPicker·PhotoSelectGrid 경유 포함' },
    { label: '인디포트폴리오 > 시공사례 목록', path: '/agents/portfolio/projects' },
    { label: '인디포트폴리오 > SNS 포스팅', path: '/agents/portfolio/sns' },
  ],
  'portfolio:PhotoPicker': [PF_WRITE],
  'portfolio:PhotoSelectGrid': [{ ...PF_WRITE, note: '직접 + PhotoPicker 경유' }],
  'portfolio:SelectedStrip': [PF_WRITE],

  // scheduler
  'scheduler:OnboardingTour': [
    { label: '인디플래너 > 스케줄 관리 > 스케줄', path: SCH_GANTT, note: '첫 방문 시에만 노출(localStorage indipia_gantt_tour_seen_v1)' },
    { ...SITES_EMBED, note: '임베드 기본 view = gantt' },
  ],
  'scheduler:ThumbImg': FR_POPUP_HOSTS.map((s) => ({ ...s, note: 'FieldReportStatusPopup 경유' })),
  'scheduler:ErrorBanner': [
    { label: '인디플래너 > 홈', path: '/agents/scheduler', note: '기본 view=calendar' },
    { label: '인디플래너 > 스케줄 관리 > 스케줄', path: SCH_GANTT, note: 'SigongPopup·FieldReportStatusPopup 경유' },
    { label: '인디플래너 > 현장 관리', path: '/agents/scheduler?view=site-list' },
    { label: '인디플래너 > 스케줄 생성 > 견적서 업로드', path: '/agents/scheduler?view=create-upload' },
    { label: '인디플래너 > 일정 공유 > 전송 이력', path: '/agents/scheduler?view=kakao-history' },
    { label: '인디플래너 > 설정 > 알림', path: '/agents/scheduler?view=settings-alarm' },
    { label: '외 7곳', path: '', note: 'cal-b2, work-type, settings-duration, settings-order, settings-partner, create-upload2(메뉴 145 스케줄 자동 생성), /sites 슬라이드오버' },
  ],
  'scheduler:EmptyState (re-export)': [],
  'scheduler:StateShell': [{ label: '외부공유 수신 화면 (공개) — 반장 일정확인 회신', path: '', note: '/share/FOREMAN_CONFIRM · 일정확인 알림톡 버튼으로 진입, 공유 토큰 필요' }],
  'scheduler:FieldReportStatusPopup': FR_POPUP_HOSTS,
  'scheduler:ForemanConfirmSettingSection': [{ label: '인디플래너 > 설정 > 시공파트너 일정확인', path: '/agents/scheduler?view=settings-foreman-confirm', note: 'ForemanConfirmSettingsView' }],
  'scheduler:TodayTodoNotiSettingRow': [{ label: '인디플래너 > 설정 > 알림', path: '/agents/scheduler?view=settings-alarm' }],
  'scheduler:ShipStatusPopup': [
    { label: '인디플래너 > 스케줄 관리 > 스케줄 > (진입: 상단 [파트너배정 / 알림발송 ▼] > 배송정보현황 · 요청)', path: SCH_GANTT },
    { label: '인디플래너 > 스케줄 관리 > 캘린더 > (진입: 상단 [파트너배정 / 알림발송 ▼] > 배송정보현황 · 요청)', path: SCH_CAL },
    { label: '인디플래너 > 스케줄 관리 > 리스트 > (진입: 상단 [파트너배정 / 알림발송 ▼] > 배송정보현황 · 요청)', path: SCH_LIST },
  ],
  'scheduler:PartnerCandidateItem': SIGONG_HOSTS,
  'scheduler:PartnerCard': [{ label: '인디플래너 > 스케줄 관리 > 스케줄', path: SCH_GANTT }, { ...SITES_EMBED, note: '임베드 gantt' }],
  'scheduler:InfoBanner': [
    { label: '인디플래너 > 스케줄 생성 > 현장 선택', path: '/agents/scheduler?view=create-site' },
    { label: '인디플래너 > 스케줄 생성 > 견적서 업로드', path: '/agents/scheduler?view=create-upload' },
    { label: '인디플래너 > 스케줄 생성 > 공종/공사일 선택', path: '/agents/scheduler?view=create-extract', note: '업로드 추출 결과 상태 필요' },
    { label: '인디플래너 > 스케줄 생성 > (자동 생성 흐름, 메뉴 145 스케줄 자동 생성)', path: '/agents/scheduler?view=create-upload2', note: 'UploadView2·ExtractView' },
  ],
  'scheduler:ForemanChangeNotice': SIGONG_HOSTS,
  'scheduler:ScheduleChangeNoticeModal': [
    { label: '인디플래너 > 스케줄 관리 > 스케줄', path: SCH_GANTT, note: '미저장 이탈 확인창에서 \'저장\' 후 어느 view 에서든 뜸' },
    { label: '인디플래너 > 스케줄 관리 > 캘린더', path: SCH_CAL },
    { label: '인디플래너 > 스케줄 관리 > 리스트', path: SCH_LIST },
    { label: '인디플래너 > 스케줄 관리 > (진입: 버튼 없음, 직접 URL 만)', path: '/agents/scheduler?view=work-type-edit', note: "navigate('work-type-edit') 호출부 없음" },
    SITES_EMBED,
  ],

  // work-log
  'work-log:ThumbImg': [WL_ORDER_LIST, { ...WL_ORDER_NEW, note: '직접 + IndiPhotoPickerModal·PhotoAttach 경유' }, WL_FR_LIST, WL_STATUS, WL_CR_EDIT, SHARE_WO, WL_REST],
  'work-log:PhotoLightbox': [WL_ORDER_LIST, { ...WL_ORDER_NEW, note: '직접 + IndiPhotoPickerModal 경유' }, WL_FR_LIST, WL_STATUS, WL_CR_EDIT, SHARE_FR, WL_REST],
  'work-log:Toast': [WL_ORDER_NEW, WL_ORDER_BULK, WL_FR_NEW, WL_STATUS, WL_CR_EDIT],
  'work-log:StatusChip': [WL_ORDER_NEW, WL_FR_NEW],
  'work-log:SiteArea': WL_PANEL,
  'work-log:SiteList': WL_PANEL.map((s) => ({ ...s, note: 'SiteArea 경유' })),
  'work-log:SitePanelProvider': WL_PANEL,
  'work-log:IndiPhotoPickerModal': [
    { ...WL_ORDER_NEW, note: '모달 — 사진첨부의 인디사진 선택 버튼' },
    { ...WL_ORDER_BULK, note: '모달' },
    { ...WL_FR_NEW, note: '모달' },
  ],
  'work-log:PhotoAttach': [WL_ORDER_NEW, WL_ORDER_BULK, WL_FR_NEW],
  'work-log:PhotoPreview': [WL_ORDER_NEW],
  'work-log:CustomerReportView': [CUSTOMER_REPORT_HIDDEN],
  'work-log:WorkOrderNoticeView': [
    { label: '인디공사현황 > 작업요청 > 작업요청 작성 > (진입: 알림톡 미리보기 버튼 → 모달)', path: '/agents/work-log/workorder/new' },
    SHARE_WO,
  ],
  'work-log:PartnerAssignModal': [{ label: '인디공사현황 > 작업요청 > 작업요청 작성 > (진입: 상단 탭 \'일괄 작업요청\' → 협력사 지정 모달)', path: '/agents/work-log/workorder/bulk' }],
  'work-log:WorkOrderTabs': [{ ...WL_ORDER_NEW, note: "탭 '공종별 작업요청'" }, WL_ORDER_BULK],
  'work-log:GroupWeather': [WL_ORDER_LIST, WL_STATUS],
  'work-log:RouteMapChart': [{ ...CUSTOMER_REPORT_HIDDEN, note: 'CustomerReportView 안에서만 쓰임 — ' + CUSTOMER_REPORT_HIDDEN.note }],
  'work-log:BarChart': [],
  'work-log:foremanChangeWarning': [{ ...WL_ORDER_NEW, note: '작업자 선택 시 기존 반장과 다르면 표시' }],
};
